import { PageHeader, useShell } from "../components/Shell";
import { PeriodControl } from "../components/Controls";
import { ActiveOnPhoneCard, DeviceSplits, useDevices } from "../components/devices";
import { FunnelCard, MixAndCountries, RetentionCard, TopEventsCard, UsageKpiCard, useUsage } from "../components/usage";
import { Card, EmptyState } from "../components/ui";
import { int } from "../lib/format";
import { useLocation } from "../lib/router";

/** Devices (phase 5) + usage, retention, funnel and top events (phase 6). Usage numbers are environment-agnostic. */
export function Usage() {
  const { apps } = useShell();
  const { search, setSearch } = useLocation();
  const appId = search.get("app") ?? "";
  const current = apps.find((a) => a.id === appId);
  const devices = useDevices(appId || null);
  const usage = useUsage(appId || null);
  const totals = devices.data?.totals;

  return (
    <>
      <PageHeader title="Gebruik" subtitle={current ? `Gefilterd op ${current.display_name ?? current.name}` : "Alle apps"}>
        <PeriodControl />
        <label className="select-wrap">
          <span className="sr-only">App</span>
          <select className="select" value={appId} onChange={(e) => setSearch({ app: e.target.value || null })}>
            <option value="">Alle apps</option>
            {apps.map((a) => (
              <option key={a.id} value={a.id}>
                {a.display_name ?? a.name}
              </option>
            ))}
          </select>
        </label>
      </PageHeader>

      <ActiveOnPhoneCard state={devices} />
      <DeviceSplits state={devices} />

      <UsageKpiCard state={usage} />

      <div className="grid-2">
        <RetentionCard state={usage} />
        <FunnelCard state={usage} />
      </div>

      <div className="grid-2">
        <TopEventsCard state={usage} />
        <Card title="Installaties volgens Apple">
          {totals && totals.total_installs > 0 && (
            <p className="tight">
              <strong>{int(totals.total_installs)}</strong> installaties geregistreerd via de SDK <span className="muted">(een herinstallatie telt opnieuw mee)</span>.
            </p>
          )}
          <EmptyState title="Apple-cijfers wachten op koppeling" icon="⇩">
            Geïnstalleerd, verwijderd en "nog op toestellen ≈" komen uit de Apple-analytics-rapporten (met vertraging en alleen bij opt-in).
          </EmptyState>
        </Card>
      </div>

      {appId ? (
        <MixAndCountries appId={appId} />
      ) : (
        <Card title="Productmix en top-landen">
          <EmptyState title="Kies een app" icon="◐">Productmix en top-landen worden per app getoond.</EmptyState>
        </Card>
      )}
    </>
  );
}
